<template>
    <div class="border-b border-[#eeeff2] py-3 flex justify-around">
        <span
            v-for="(btn, index) in sections"
            :key="index"
            @click="activeSection = index"
            :class="{ 'text-[#366fed]': activeSection === index }"

            class="block text-[20px] font-[CircularBook] text-center cursor-pointer"
        >
            {{ btn }}
        </span>
    </div>
    <form class="flex items-center max-w-lg px-5 pt-2.5 pb-2">
        <div class="relative w-full">
            <input v-model="searchPair" type="text" class="bg-white border border-[#eeeff2] text-gray-900 text-sm rounded-[5px] focus:bg-white block w-full pe-10 p-2.5" placeholder="Search" required />
            <button type="button" class="absolute inset-y-0 end-0 flex items-center pe-3">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m20.647 18.22-4.095-3.841c1.369-1.523 2.197-3.486 2.197-5.629C18.75 3.925 14.565 0 9.421 0 4.278 0 .094 3.925.094 8.75S4.278 17.5 9.42 17.5a9.653 9.653 0 0 0 6.001-2.061l4.095 3.841c.155.146.36.22.565.22a.82.82 0 0 0 .565-.22.717.717 0 0 0 0-1.06zM1.693 8.75c0-3.998 3.466-7.25 7.728-7.25s7.73 3.252 7.73 7.25S13.682 16 9.42 16c-4.262 0-7.728-3.252-7.728-7.25z" fill="#A4A6AA"/>
                </svg>
            </button>
        </div>
    </form>
    <div class="relative overflow-x-auto">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap">
            <thead>
            <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                <th scope="col" class="ps-5 pe-2 pb-2.5">
                    Pair
                </th>
                <th scope="col" class="px-2 pb-2.5 text-right">
                    Price
                </th>
                <th scope="col" class="pe-5 ps-2 pb-2.5 text-right">
                    Change
                </th>
            </tr>
            </thead>
            <tbody
                v-for="(pair, index) in sections"
                v-show="activeSection === index"
                :data-index="index"
                :key="pair"
                class="text-[12px] font-[CircularBook]"
            >
            <tr
                v-for="market in filteredPairs(pair)" :key="market.id"
            >
                <td class="ps-5 pe-2 py-[0] text-[#366fed]">
                    <a :title="market.title_formatted" :href="`/exchange/` + market.title">{{ market.title_formatted }}</a>
                </td>
                <td class="px-2 py-[0] text-right">
                    {{ parseFloat(market.last_price).toFixed(market.price_decimals) }}
                </td>
                <td class="pe-5 px-2 py-[0] text-right" :class="market.change_day < 0 ? 'text-danger' : market.change_day > 0 ? 'text-success' : '' ">
                    {{ market.change_day }}%
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import {onMounted, ref} from "vue";
import {backendSocket} from "../../sockets";

const pairs = ref(pageData.pairs)
const searchPair = ref("")
const activeSection = ref(0);
const sections = ['BTC', 'USDT', 'ALTS'];

onMounted(async () => {
    backendSocket.channel('market.public').listen('.market_data.updated', ({marketData}) => {
        const foundIndex = pairs.value[marketData.tab].findIndex((el) => el.id === marketData.id)

        const newPairs = pairs.value;
        newPairs[marketData.tab][foundIndex] = marketData;

        pairs.value = newPairs;
    });
    switch (pageData.market.to_cgw_currency.slug) {
        case 'BTC':
            activeSection.value = 0;
            break;
        case 'USDT':
            activeSection.value = 1;
            break;
        default:
            activeSection.value = 2
    }
});

const filteredPairs = (pair) => {
    return pairs.value[pair]?.filter((market) => market.title_formatted.includes(searchPair.value.toUpperCase()))
}

</script>
